import * as Sentry from '@sentry/vue'

export function setupSentry(app, router) {
  if (process.env.NODE_ENV !== 'development' && window.sentry_dsn !== '') {
    Sentry.init({
      app,
      dsn: window.sentry_dsn,
      environment: window.sentry_environment,
      tunnel: '/sentry-tunnel',
      integrations: [
        Sentry.vueIntegration({
          tracingOptions: {
            tracePropagationTargets: ['localhost', /^\//]
          }
        }),
        Sentry.replayIntegration({
          unblock: ['.sentry-unblock, [data-sentry-unblock]'],
          unmask: ['.sentry-unmask, [data-sentry-unmask]']
        })
      ],
      tracesSampleRate: 1.0,
      // Session Replay
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0
    })

    Sentry.getCurrentScope().setUser({
      id: window.user_id,
      email: window.user_email,
      first_name: window.user_first_name,
      last_name: window.user_last_name
    })
  }
}
